import { render, staticRenderFns } from "./CountryTranslationEditPopup.vue?vue&type=template&id=6d40c7d5&"
import script from "./CountryTranslationEditPopup.vue?vue&type=script&lang=js&"
export * from "./CountryTranslationEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports